import { esCrafterList, esCrafterXb } from '../../../common/EsCrafter';

const TICK = 'M5.8535 12.6631C5.65824 12.8584 5.34166 12.8584 5.1464 12.6631L0.678505 8.1952C0.483242 7.99994 0.483242 7.68336 0.678505 7.4881L2.32921 5.83739C2.52467 5.64193 2.84166 5.64216 3.03684 5.83791L5.14622 7.95354C5.34147 8.14936 5.65859 8.14952 5.85403 7.95388L13.3797 0.420561C13.575 0.22513 13.8917 0.225051 14.087 0.420383L15.7381 2.07143C15.9333 2.26669 15.9333 2.58327 15.7381 2.77854L5.8535 12.6631Z';

const BODY = 'text-base font-medium leading-relaxed text-body sm:text-lg sm:leading-relaxed';

/* EsHomePrinciples' two columns from a points block: the ticked points split into two
   halves as the principles are, and the headed blurbs beside them. */
export default function EsBlockPoints( { slug, block, item } ) {
    const aId = `es-${ slug }-${ block.key_s }`;
    const aPoints = esCrafterList( block.points_o );
    const aBlurbs = esCrafterList( block.blurbs_o );
    const aHalf = Math.ceil( aPoints.length / 2 );

    const point = ( pPoint ) => (
        <p key={ pPoint.key_s } data-testid={ `${ aId }-point-${ pPoint.key_s }` } className="mb-5 flex items-center text-lg font-medium text-body">
            <span className="mr-4 flex items-center justify-center text-accent w-[30px] h-[30px]">
                <svg width="16" height="13" viewBox="0 0 16 13" className="fill-current"><path d={ TICK } /></svg>
            </span>
            { pPoint.label_s }
        </p>
    );

    return (
        <section id={ block.key_s } data-testid={ aId } className="pt-[50px]" { ...esCrafterXb( item, block ) }>
            <div className="container">
                <div className="border-t border-section-rule pt-[100px]">
                    <div className="flex flex-wrap items-center mx-[-16px]">
                        <div className="w-full px-4 lg:w-1/2">
                            <div className="mb-12 max-w-[610px] wow fadeInUp lg:mb-0" data-wow-delay=".15s">
                                <h2 data-testid={ `${ aId }-title` } { ...esCrafterXb( item, block, 'title_s' ) }
                                    className="mb-6 text-3xl font-bold leading-tight text-heading sm:text-4xl sm:leading-tight md:text-[45px] md:leading-tight lg:text-4xl lg:leading-tight xl:text-[45px] xl:leading-tight">
                                    { block.title_s }
                                </h2>
                                <p data-testid={ `${ aId }-intro` } className={ 'mb-10 pr-9 ' + BODY } { ...esCrafterXb( item, block, 'intro_t' ) }>{ block.intro_t }</p>
                                <p data-testid={ `${ aId }-promise` } className={ 'mb-7 ' + BODY } { ...esCrafterXb( item, block, 'promise_t' ) }>{ block.promise_t }</p>
                                <div className="flex flex-wrap mx-[-12px]">
                                    <div className="w-full px-3 sm:w-1/2 lg:w-full xl:w-1/2">{ aPoints.slice( 0, aHalf ).map( point ) }</div>
                                    <div className="w-full px-3 sm:w-1/2 lg:w-full xl:w-1/2">{ aPoints.slice( aHalf ).map( point ) }</div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full px-4 lg:w-1/2">
                            <div className="max-w-[500px] wow fadeInUp" data-wow-delay=".2s">
                                { aBlurbs.map( ( pBlurb, pIndex ) => (
                                    <div key={ pBlurb.key_s } className={ pIndex === aBlurbs.length - 1 ? 'mb-1' : 'mb-9' }>
                                        <h3 data-testid={ `${ aId }-blurb-${ pBlurb.key_s }-heading` } className="blurbHeading">{ pBlurb.heading_s }</h3>
                                        <p data-testid={ `${ aId }-blurb-${ pBlurb.key_s }` } className={ BODY }>{ pBlurb.body_t }</p>
                                    </div>
                                ) ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
